import routesDefault from 'app/routes/default';
export const routes = routesDefault;
